import { Column } from "react-table";

import { ITableProps } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IProcessJobError } from "src/core/process-job/api/processJobs.api";

export type IUserImportErrorsColumns = Partial<ITableProps>;

export const userImportErrorsTableColumns = (): Array<Column<IProcessJobError<"import-file-price">>> => [
  globalTableColumns.id(),
  globalTableColumns.standardText({
    Header: "Line Number",
    accessor: "data.LineNumber",
    width: 100,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Message",
    accessor: "message",
    multiLine: true,
    width: 300
  }),
  globalTableColumns.standardText({
    Header: "First Name",
    accessor: "data.FirstName",
    width: 150,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Last Name",
    accessor: "data.LastName",
    width: 150,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Email",
    accessor: "data.EmailAddress",
    width: 150,
    sortable: false,
    filterable: false
  })
];
